module.exports = __webpack_public_path__ + "static/Joshua.cf6a41c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Joshua.jpg
// module id = 1302
// module chunks = 137408898365125